// salonjobs LP の LINE 公式アカウント直 CTA。
// 設計: cajon-inc/design-docs docs/salonjobs-45091-lp-line-direct-cta.md
// salonjobs_salons.line_official_id（@ 付き公式 ID）から友だち追加 URL を組み立てる。
// 保存規約（console 側）と同じ防御: URL やパス区切りを含む値は出さない。

export function salonjobsLineOfficialUrl(rawId: string | null | undefined): string | null {
  const id = rawId?.trim();
  if (!id) return null;
  if (/[:/]/.test(id) || /https?/i.test(id)) return null;
  const normalized = id.startsWith("@") ? id : `@${id}`;
  return `https://line.me/R/ti/p/${normalized}`;
}
